import moment from 'moment'

import { VALIDATION_MESSAGES } from './constants/messages'

export const phoneNumberValidation = (rule, value) => {
  if (
    !value ||
    /^(\+\d{1,3}(\s)?)?((\(\d{3}\))|\d{3})[- .]?\d{3}[- .]?\d{4}$/.test(value)
  ) {
    return Promise.resolve()
  }
  return Promise.reject(VALIDATION_MESSAGES.phoneNumberPatternMessage)
}

export const emailValidation = (rule, value) => {
  if (value) {
    const emailAddresses = value.split(',')
    for (const emailAddress of emailAddresses) {
      if (
        !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(
          emailAddress.trim()
        )
      ) {
        return Promise.reject(VALIDATION_MESSAGES.emailAddressPatternMessage)
      }
    }
  }

  return Promise.resolve()
}
export const deliveryPercentageValidation = (rule, value) => {
  // Emptiness is the `required` rule's job (deliveryPercentageRule) -- this
  // validator only judges range, so an empty field surfaces exactly one
  // message instead of both rules rejecting the same field at once.
  if (value === '' || value === undefined || value === null) {
    return Promise.resolve()
  }
  const numericValue = Number(value)
  if (isNaN(numericValue) || numericValue < 0 || numericValue > 100) {
    return Promise.reject(VALIDATION_MESSAGES.deliveryPercentageMessage)
  }
  return Promise.resolve()
}

export const crHoursValidation = (rule, value) => {
  const numericValue = Number(value)
  if (value === '' || value === undefined || value === null || isNaN(numericValue) || numericValue <= 0) {
    return Promise.reject(VALIDATION_MESSAGES.crHoursMessage)
  }
  return Promise.resolve()
}

export const crApprovalDateValidation = (rule, value) => {
  if (value && moment(value).isAfter(moment(), 'day')) {
    return Promise.reject(VALIDATION_MESSAGES.crApprovalDateFutureMessage)
  }
  return Promise.resolve()
}

// Day-level check so the time-of-day a DatePicker attaches never counts.
export const isOnOrBeforeDay = (date, referenceDate) =>
  Boolean(date && referenceDate) &&
  !moment(date).isAfter(moment(referenceDate), 'day')

export const whitespaceRegEx = /^\S+$/
export const nameRegex = /^[a-zA-Z]+( [a-zA-Z]+)*$/
export const websiteRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
export const passwordRegEx =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d!@#$%^&*]{8,20}$/
// Letters, digits, spaces, and punctuation commonly found in legitimate
// company names (e.g. "AT&T", "O'Reilly", "Simform Solutions Pvt. Ltd.").
export const companySearchTextRegex = /^[a-zA-Z0-9 .,'&()-]*$/
export const COMPANY_SEARCH_MAX_LENGTH = 100

